import React from 'react';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card';
import { Palette, Settings, ReportProblem } from 'material-ui-icons';

import ContactForm from '../../form/contact';
import Parallax from '../../section';
import codebg from '../../../img/code-bg-v3.jpg';
import servers from '../../../img/website-server-hosting.jpg';

export const SmoothScroll = {
  timer: null,

  stop() {
    clearTimeout(this.timer);
  },

  scrollTo(id, callback) {
    const settings = {
      duration: 1000,
      easing: {
        outQuint(x, t, b, c, d) {
          return (c * (((t = (t / d) - 1) * t * t * t * t) + 1)) + b;
        },
      },
    };

    let percentage = 0;
    const startTime = Date.now();
    const node = document.getElementById(id);
    const nav = document.getElementById('nav');
    const nodeTop = node.offsetTop;
    const nodeHeight = node.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight,
    );
    const windowHeight = window.innerHeight;
    const offset = window.pageYOffset;
    const delta = nodeTop - offset;
    const bottomScrollableY = height - windowHeight;
    const targetY = (bottomScrollableY < delta) ?
    bottomScrollableY - ((height - nodeTop - nodeHeight) + offset) :
      delta - nav.offsetHeight;

    if (this.timer) {
      clearInterval(this.timer);
    }

    function step() {
      const elapsed = Date.now() - startTime;

      if (elapsed > settings.duration) {
        clearTimeout(this.timer);
      }

      percentage = elapsed / settings.duration;

      if (percentage > 1) {
        clearTimeout(this.timer);

        if (callback) {
          callback();
        }
      } else {
        const yScroll = settings.easing.outQuint(0, elapsed, offset, targetY, settings.duration);
        window.scrollTo(0, yScroll);
        this.timer = setTimeout(step, 10);
      }
    }

    this.timer = setTimeout(step, 10);
  },
};

const paper = {
  backgroundColor: '#F4F4F4',
  padding: '20px 0',
};

const style = {
  serviceimg: {
    color: '#4caf50',
    display: 'block',
    width: '50%',
    height: 'auto',
    margin: 'auto',
    padding: '20px 0',
  },
};

export const Home = () => (
  <div className="main">
    <Parallax
      image={codebg}
      style={{ padding: '100px 0' }}
    >
      <Typography
        align="center"
        type="display2"
        style={
          { color: 'white' }
        }
      >
        Scalable and Affordable Web Solutions
      </Typography>
      <Typography
        align="center"
        type="subheading"
        style={
          { color: 'white' }
        }
      >
        We build websites and applications tailored to your business.
      </Typography>
      <Button
        raised
        color="primary"
        className="button-cta"
        style={{ textAlign: 'center', display: 'block', margin: '10px auto' }}
        onTouchTap={() => { SmoothScroll.scrollTo('services'); }}
      >
        Our Services
      </Button>
    </Parallax>
    <Paper
      id="services"
      style={paper}
    >
      <Typography
        align="center"
        type="title"
      >
        Our Services
      </Typography>
      <div
        className="section"
        style={{
          margin: '0 auto',
          padding: '20px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Grid container>
          <Grid item xs={4} className="service-card">
            <Card>
              <CardMedia>
                <Palette style={style.serviceimg} />
              </CardMedia>
              <CardContent>
                <Typography type="headline" component="h2">
                  Web Design
                </Typography>
                <Typography component="p">
                  We can build you a website that not only functions well,
                  but looks good doing it. Our designs will impress your
                  users and make your competitors envious.
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  raised
                  color="primary"
                  className="button-cta"
                  onTouchTap={() => { SmoothScroll.scrollTo('contact-us'); }}
                >
                  Contact Us
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={4} className="service-card">
            <Card>
              <CardMedia>
                <Settings style={style.serviceimg} />
              </CardMedia>
              <CardContent>
                <Typography type="headline" component="h2">
                  Web Development
                </Typography>
                <Typography component="p">
                  Custom functionality on the web is our forte. If you have
                  an idea, we can make it a reality. We&apos;ve built things from
                  simple plugins to complex e-commerce analytics.
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  raised
                  color="primary"
                  className="button-cta"
                  onTouchTap={() => { SmoothScroll.scrollTo('contact-us'); }}
                >
                  Contact Us
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={4} className="service-card">
            <Card>
              <CardMedia>
                <ReportProblem style={style.serviceimg} />
              </CardMedia>
              <CardContent>
                <Typography type="headline" component="h2">
                  Website Maintenance
                </Typography>
                <Typography component="p">
                  If your website is having problems, we have the fix. Our experienced
                  developers can pinpoint the issue quickly so you can get your
                  website running and back in business.
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  raised
                  color="primary"
                  className="button-cta"
                  onTouchTap={() => { SmoothScroll.scrollTo('contact-us'); }}
                >
                  Contact Us
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    </Paper>
    <Parallax image={servers}>
      <Typography
        type="title"
        style={{ color: 'white', marginBottom: '20px' }}
      >
        Who We Are
      </Typography>

      <Typography type="body1" style={{ color: 'white', marginBottom: '20px' }}>
        Founded in Northern Idaho in 2016, All Bits On is a web development company that
        strives to be at the top of the pack when it comes to <strong>affordable website
        building, hosting, and maintenance</strong>. With our combined several years
        experience in <strong>Full Stack Web Development, Systems Administration, and
        Dev Ops</strong>, you can rest assured you&apos;ll be getting exactly what
        you want.
      </Typography>

      <Typography type="body1" style={{ color: 'white' }}>
        All Bits On is run by its two co-founders, Brandon Aikey and Brian Green. Both
        attended and graduated from the same college, and took many of their Computer
        Science classes together. Because of their background of working together on
        essentially all of their projects, they make a cohesive team, and play to each
        other&apos;s strengths. They&apos;re also huge nerds, who enjoy video games, sushi, rock
        music, zombies, and watching Game of Thrones.
      </Typography>
    </Parallax>
    {/*
    <div className="section full-width">
      <div className="inner">
        <div className="row">
          <div className="col col-6">
            <img src={webteam} alt="AllBitsOn Web Design Logo" />
          </div>
          <div className="col col-6">
            <h2>What We Do</h2>

            <p>Our team at All Bits On is like our servers - dedicated. Our primary goal is to
              form a lasting relationship with all of our clients by providing the perfect
              solution for their web presence. We work hard to ensure all the i&apos;s are
              dotted and all the t&apos;s are crossed when it comes to our client&apos;s
              satisfaction.</p>
            <p>We offer a wide range of services and solutions, including, but not limited
              to:</p>
            <ul className="services">
              <li>Solid Website Hosting</li>
              <li>Detailed Website Maintenance</li>
              <li>Fast Website Repair</li>
              <li>Custom Functionality Development</li>
              <li>Monthly Retainer Packages</li>
            </ul>
          </div>
        </div>
        <div className="clear" />
      </div>
    </div>
    */}
    <ContactForm />
  </div>
);

export const PrivacyPolicy = () => (
  <div className="main">
    Privacy Policy Body.
  </div>
);

export const Default = () => (
  <div>
    Default Body. (404 Page)
  </div>
);



// WEBPACK FOOTER //
// ./src/components/layout/body/index.js